import { useEffect, useState } from 'react';
import styled from 'styled-components';
import pin from 'src/assets/images/user-mobile/parking/area-pin.png';
import { apiParking } from 'src/apis/utils/parking';
import {
  djdroneparkingList,
  wheatparkingList,
} from 'src/assets/database/parkingData';
import ParkingBox from './ParkingBox';

export interface ParkingPlaceResponse {
  id: number;
  name: string;
  latitude: number;
  longitude: number;
  congestionLevel: 'LOW' | 'MEDIUM' | 'HIGH' | 'FULL';
  parkingPlaceEnabled: boolean;
  area: string;
}

export interface ParkingLot {
  name: string;
  distance: string;
  latitude: number;
  longitude: number;
  address: string;
  complexity: string;

  accessurl: string;
}

export default function ParkingList({ festivalId }: { festivalId: number }) {
  const [groupedParking, setGroupedParking] = useState<
    Record<string, ParkingLot[]>
  >({});

  useEffect(() => {
    if (!festivalId) return;
    const fetchParkingData = async () => {
      try {
        const { data } = await apiParking.getParkingInfo(festivalId);
        const originList =
          festivalId === 7
            ? djdroneparkingList
            : festivalId === 9
              ? wheatparkingList
              : [];
        const convertedPlaces: ParkingLot[] = data.parkingPlaces.map(
          (place: ParkingPlaceResponse) => {
            // 기존 parkingList에서 정보 찾아오기
            const origin = originList
              .flatMap(p => p.lots)
              .find(lot => lot.name === place.name);

            return {
              name: place.name,
              distance: origin?.distance || '',
              latitude: origin?.latitude || 0,
              longitude: origin?.longitude || 0,
              address: origin?.address || '',
              complexity: place.parkingPlaceEnabled
                ? place.congestionLevel
                : '운영마감',
            };
          },
        );

        const grouped = convertedPlaces.reduce<Record<string, ParkingLot[]>>(
          (acc, cur) => {
            const area = data.parkingPlaces.find(
              (p: ParkingPlaceResponse) => p.name === cur.name,
            )?.area;
            if (!area) return acc;
            if (!acc[area]) acc[area] = [];
            acc[area].push(cur);
            return acc;
          },
          {},
        );

        // area 오름차순 정렬
        const sorted = Object.keys(grouped)
          .sort()
          .reduce(
            (acc, key) => {
              acc[key] = grouped[key];
              return acc;
            },
            {} as Record<string, ParkingLot[]>,
          );

        setGroupedParking(sorted);
      } catch (err) {
        console.error('주차장 정보 불러오기 실패', err);
      }
    };

    fetchParkingData();
  }, [festivalId]);

  return (
    <>
      {Object.entries(groupedParking).map(([area, list]) => (
        <div key={area}>
          {area !== '0구역' && (
            <ListBox>
              <img src={pin} alt="pin" width={20} height={20} />
              {area}
            </ListBox>
          )}
          <ParkingBox parkingList={list} festivalId={festivalId} />
        </div>
      ))}
    </>
  );
}

const ListBox = styled.div`
  margin-top: 8px;
  padding: 16px 0 0 20px;
  color: var(--Font-02_black, #111);
  font-size: 22px;
  font-weight: 700;
  line-height: 34px;
  background-color: #ffffff;
  img {
    margin-top: 4px;
  }
`;
